var map = {
	"./barImageLarge.png": 6196,
	"./fastfoodImageLarge.png": 3687,
	"./hospitalImageLarge.png": 8537,
	"./libraryImageLarge.png": 9272,
	"./parkingImageLarge.png": 4358,
	"./picnicSiteImageLarge.png": 7493,
	"./pubImageLarge.png": 7464,
	"./railwayImageLarge.png": 4827,
	"./restaurantImageLarge.png": 8735,
	"./taxiImageLarge.png": 3689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9723;